import React from 'react';
import PropTypes from 'prop-types';
import './SearchBar.css';
import {
  FormControl,
  FormGroup,
  Glyphicon,
  InputGroup,
  Navbar,
} from 'react-bootstrap';

export default function SearchBar(props) {
  const handleClear = () => {
    if (props.onClearText !== null) {
      props.onClearText();
    }
  };

  const handleSearch = () => {
    if (props.onSearch !== null) {
      props.onSearch(props.searchText);
    }
  };

  const handleValueChange = (event) => {
    if (props.onSearchTextChange !== null) {
      props.onSearchTextChange(event.target.value);
    }
  };

  const {
    addButton,
    children,
    searchPlaceHolder,
    searchText,
    onSearch,
  } = props;

  return (
    <div className="search-bar">
      {children}
      {(addButton !== null || onSearch !== null) && (
        <Navbar.Form className="search-bar-form" pullRight>
          {onSearch !== null && (
            <FormGroup>
              <InputGroup>
                <FormControl
                  className="search-input"
                  placeholder={searchPlaceHolder}
                  type="text"
                  value={searchText}
                  onChange={handleValueChange}
                />
                {searchText !== '' && (
                  <InputGroup.Addon
                    className="search-buttons remove"
                    onClick={handleClear}
                  >
                    <Glyphicon glyph="remove" />
                  </InputGroup.Addon>
                )}
                <InputGroup.Addon
                  className="search-buttons magnifier"
                  onClick={handleSearch}
                >
                  <Glyphicon glyph="search" />
                </InputGroup.Addon>
              </InputGroup>
            </FormGroup>
          )}
          {addButton !== null && addButton}
        </Navbar.Form>
      )}
    </div>
  );
}

SearchBar.propTypes = {
  addButton: PropTypes.any, // Button to show next to search input
  searchPlaceHolder: PropTypes.string,
  searchText: PropTypes.string,
  onClearText: PropTypes.func,
  onSearch: PropTypes.func,
  onSearchTextChange: PropTypes.func,
};

SearchBar.defaultProps = {
  addButton: null,
  searchPlaceHolder: 'Search',
  searchText: '',
  onClear: null,
  onSearch: null,
  onSearchTextChange: null,
};



// WEBPACK FOOTER //
// ./src/components/shared/navigation/SearchBar.js